module.exports = __webpack_public_path__ + "img/cp-diver-3.13c16fbc.svg";